/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 11:07:01
 */
import { aseEncode, aseDecode } from '@/js/utils'
//同步
const mutations = {
    //设置appName
    SET_APP_NAME(state, payload) {
        state.baseInfo.appName = payload
    },
    //设置companyName
    SET_COMPANY_NAME(state, payload) {
        state.baseInfo.companyName = payload
    },
    //设置机构名称organizationName
    SET_ORGANIZATION_NAME(state, payload) {
        state.baseInfo.organizationName = payload
    },
    //设置机构名称organizationName
    SET_ORGANIZATION_NICK_NAME(state, payload) {
        state.baseInfo.organizationNickName = payload
    },
    SET_IS_LOGIN(state, payload) {
        state.userID = payload;
    },
    // 设置角色ID
    SET_USER_ID(state, payload) {
        // state.userID = aseEncode(payload, "Wechat-8847￥￥%ERF_)((^%4dkfj&45");
        state.userID = payload;
    },
    // 重定向路由
    SET_FULL_PATH(state, payload) {
        state.fullPath = payload;
    },
    
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js